module.exports = __webpack_public_path__ + "static/media/b9-logo.7989a8b1.png";